export default __webpack_public_path__ + "static/media/task-square.d713b86b.svg";